import { render, staticRenderFns } from "./Clear.vue?vue&type=template&id=562f0d10&scoped=true&"
import script from "./Clear.vue?vue&type=script&lang=ts&"
export * from "./Clear.vue?vue&type=script&lang=ts&"
import style0 from "./Clear.vue?vue&type=style&index=0&id=562f0d10&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562f0d10",
  null
  
)

export default component.exports